<template>
  <div class="import-indicators">
    <el-dialog
      title="导入数据"
      :visible.sync="dialogdata"
      width="600px"
      style="text-align: left"
      :close-on-click-modal="false"
      @open="opendialog"
    >
      <div class="uploadbox">
        <el-upload
          class="avatar-uploader"
          name="image"
          :action="uploadUrl"
          :data="uploadExtraData"
          :headers="uploadHeaders"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeUpload"
        >
          <el-button
            plain
            v-if="file_name"
          >重新选择</el-button>
          <el-button
            plain
            v-else
          >选择文件</el-button>
        </el-upload>
        <div
          class="filebox"
          v-if="file_name"
        >
          <div>
            <span>上传文件：</span>
            <span style="color: #666">{{ file_name }}</span>
          </div>
          <div style>
            <span>文件大小：</span>
            <span style="color: #666">{{ file_size }}kb</span>
          </div>
          <div>
            <span>成功条数：</span>
            <span style="color: #666">{{ success_count }}条</span>
          </div>
          <div v-if="fail_count">
            <span>错误数据：</span>
            <span style="color: #ff514b">{{ fail_count }}条，行数：{{ fail_row }}</span>
          </div>
        </div>
        <div class="msgbox">
          <el-button
            type="text"
            style="font-weight: 600"
            @click="download"
          >下载指标模板</el-button>
          <ul style="color: #999">
            <li>请按照模板格式完整填写数据后导入，否则无法导入</li>
            <li>已创建指标无法再次导入</li>
            <li>最大支持1MB的Excel文件</li>
            <li>错误数据可对照文件行数修改数据后重新导入</li>
            <li>导入指标需要时间，请耐心等待</li>
          </ul>
        </div>
      </div>
      <div class="btn-box">
        <el-button
          type="primary"
          @click="close"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import staff from '@/api/staff';
import constant from '@/service/common/constant';
export default {
  props: ['isFlag'],
  data() {
    return {
      dialogdata: false,
      uploadExtraData: {
        img_type: 6,
        suffix: '.xls'
      },
      file_name: '',
      file_size: '',
      success_count: '',
      fail_count: '',
      fail_row: ''
    };
  },
  watch: {
    isFlag() {
      this.dialogdata = true;
    }
  },
  computed: {
    uploadUrl() {
      if (process.env.NODE_ENV == 'development') {
        // 本地开发使用 api 前缀
        return '/api/platform/upload/uploadFile';
      } else {
        return '/platform/upload/uploadFile';
      }
    },
    uploadHeaders: function () {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ['version', 'platform']),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken
        }
      );
    }
  },
  methods: {
    //提交
    close() {
      this.dialogdata = false;
      this.$emit('refreshList');
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，请删除后继续上传`);
    },
    //上传之前
    beforeUpload(file) {
      const isText = file.type === 'application/vnd.ms-excel';
      const isTextComputer =
        file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const isLt1M = file.size / 1024 / 1024 < 1;
      const suffix = file.name.substring(file.name.lastIndexOf('.'));
      this.uploadExtraData.suffix = suffix;
      if (!isText && !isTextComputer) {
        this.$message.error('上传文件只能是CSV或Excel文件');
        return false;
      }
      if (!isLt1M) {
        this.$message.error('最大支持1MB的文件!');
        return false;
      }
      return (isText && isLt1M) || (isTextComputer && isLt1M);
    },
    //上传成功
    handleAvatarSuccess(res, file, fileList) {
      if (res.code === 0) {
        let params = { target_pic: res.data.pic };
        console.log(params);
        staff
          .importTarget(params)
          .then((res) => {
            if (res.code == 0) {
              this.file_name = file.name;
              this.file_size = (file.size / 1024).toFixed(2);
              this.success_count = res.data.success_row_count;
              this.fail_count = res.data.fail_row_count;
              this.fail_row = res.data.row;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    //下载指标模板
    download() {
      let host =
        document.location.protocol +
        '//' +
        window.location.host +
        '/upload/target_template.xls';
      location.href = host;
    },
    opendialog() {
      this.file_name = '';
      this.file_size = '';
      this.success_count = '';
      this.fail_count = '';
      this.fail_row = '';
    }
  }
};
</script>
<style lang="scss" scoped>
.import-indicators {
  .uploadbox {
    padding: 20px;
    box-sizing: border-box;
    border-top: 1px solid #dcdcde;
  }
  .btn-box {
    display: flex;
    justify-content: flex-end;
    padding: 10px;
    border-top: 1px solid #dcdcde;
  }
}
</style>
